
import classNames from 'classnames';
import React, { JSX, useCallback } from 'react';
import { Badge } from '@fluentui/react-components';
import { Star16Regular, Warning16Regular } from '@fluentui/react-icons';

import { usePerformanceTagStyles } from '../styles/performance-tag-styles';
import { Asset } from './types';

const LABEL_STRING = {
  Low: _TL_('Low'),
  Good: _TL_('Good'),
  Best: _TL_('Best'),
  Learning: _TL_('Learning'),
  Unrated: _TL_('Unrated'),
};

function getStyle(label: string, styles: Record<'low' | 'neutral' | 'high', string>): string {
  switch (label) {
    case 'Low':
      return styles.low;
    case 'Learning':
    case 'Unrated':
      return styles.neutral;
    case 'Good':
    case 'Best':
      return styles.high;
    default:
      return styles.neutral;
  }
}

function getIcon(label: string): JSX.Element | undefined {
  if (label === 'Best') {
    return <Star16Regular />;
  }
  if (label === 'Low') {
    return <Warning16Regular />;
  }
  return undefined;
}

export function useGetPerformanceTag(i18n: any) {
  const styles = usePerformanceTagStyles();
  return useCallback((asset: Asset): JSX.Element => (
    <Badge className={classNames('perf-tag', getStyle(asset.PerformanceLabel, styles))} shape="circular" appearance="outline" iconPosition="before" icon={getIcon(asset.PerformanceLabel)}>
      {i18n.getString(LABEL_STRING[asset.PerformanceLabel])}
    </Badge>), [i18n, styles]);
}
